function setModal (type, payload) {
  return (dispatch) => {
    dispatch({
      type,
      payload
    })
  }
}

export {
  setModal
}



// WEBPACK FOOTER //
// ./src/store/actions/modal.js